import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Facebook, Twitter, Instagram, Youtube, Linkedin } from 'lucide-react';

const socialLinks = [
  { name: 'Facebook', icon: Facebook, href: 'https://facebook.com/barnsandpastures', color: 'hover:text-[#1877F2]' },
  { name: 'Twitter', icon: Twitter, href: 'https://twitter.com/barnsandpastures', color: 'hover:text-[#1DA1F2]' },
  { name: 'Instagram', icon: Instagram, href: 'https://instagram.com/barnsandpastures', color: 'hover:text-[#E4405F]' },
  { name: 'YouTube', icon: Youtube, href: 'https://youtube.com/barnsandpastures', color: 'hover:text-[#FF0000]' },
  { name: 'LinkedIn', icon: Linkedin, href: 'https://linkedin.com/company/barnsandpastures', color: 'hover:text-[#0A66C2]' },
];

export const Footer = () => {
  return (
    <footer className="py-16 bg-farmhouse-charcoal border-t border-farmhouse-subtle">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <MapPin className="w-6 h-6 text-farmhouse-saddle" />
              <span className="font-serif text-lg font-semibold text-farmhouse-cream">
                Barns & Pastures
              </span>
            </Link>
            <p className="text-farmhouse-muted text-sm leading-relaxed mb-4">
              The trusted marketplace for horse and livestock boarding across all 50 states.
            </p>
            {/* Social Links */}
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`p-2 bg-farmhouse-paper rounded-md text-farmhouse-muted transition-colors ${social.color}`}
                  aria-label={social.name}
                >
                  <social.icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Explore */}
          <div>
            <h4 className="font-serif text-farmhouse-cream font-semibold mb-4">Explore</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/search" className="text-farmhouse-muted hover:text-farmhouse-saddle transition-colors">
                  Browse Listings
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-farmhouse-muted hover:text-farmhouse-saddle transition-colors">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-farmhouse-muted hover:text-farmhouse-saddle transition-colors">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Host */}
          <div>
            <h4 className="font-serif text-farmhouse-cream font-semibold mb-4">Host</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/auth?role=host" className="text-farmhouse-muted hover:text-farmhouse-saddle transition-colors">
                  Become a Host
                </Link>
              </li>
              <li>
                <Link to="/help" className="text-farmhouse-muted hover:text-farmhouse-saddle transition-colors">
                  Host Resources
                </Link>
              </li>
              <li>
                <Link to="/blog/hosting-tips-beginners" className="text-farmhouse-muted hover:text-farmhouse-saddle transition-colors">
                  Hosting Tips
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-serif text-farmhouse-cream font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="text-farmhouse-muted hover:text-farmhouse-saddle transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/about#team" className="text-farmhouse-muted hover:text-farmhouse-saddle transition-colors">
                  Our Team
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-farmhouse-muted hover:text-farmhouse-saddle transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/help" className="text-farmhouse-muted hover:text-farmhouse-saddle transition-colors">
                  Help Center
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="font-serif text-farmhouse-cream font-semibold mb-4">Connect</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="https://facebook.com/barnsandpastures" target="_blank" rel="noopener noreferrer" className="text-farmhouse-muted hover:text-farmhouse-saddle transition-colors">
                  Facebook
                </a>
              </li>
              <li>
                <a href="https://instagram.com/barnsandpastures" target="_blank" rel="noopener noreferrer" className="text-farmhouse-muted hover:text-farmhouse-saddle transition-colors">
                  Instagram
                </a>
              </li>
              <li>
                <a href="https://twitter.com/barnsandpastures" target="_blank" rel="noopener noreferrer" className="text-farmhouse-muted hover:text-farmhouse-saddle transition-colors">
                  Twitter
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-farmhouse-subtle flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-farmhouse-muted">
            © 2025 Barns & Pastures. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm text-farmhouse-muted">
            <a href="#" className="hover:text-farmhouse-cream transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-farmhouse-cream transition-colors">Terms of Service</a>
            <a href="#" className="hover:text-farmhouse-cream transition-colors">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
